import axios from '@api';

/**
 * Fetches the app context from the server.
 */
export const readAppContext = () => {
  return axios({
    method: 'get',
    url: '/api/appcontext',
    withCredentials: true,
  });
};
